import { apiUrl } from 'util/apiUrl';
import { useQueries } from 'react-query';
import {
  ContentType,
  useAuthenticatedFetch,
} from 'hooks/util/useAuthenticatedFetch';

export const useOrganizationByIds = (ids: string[]) => {
  const fetch = useAuthenticatedFetch(ContentType.NO_ORGANIZATION_HEADER);

  return useQueries(
    ids.map((id) => {
      return {
        queryKey: ['organizationsById', id],
        queryFn: () =>
          fetch(`${apiUrl}/Organizations/${id}`),
        enabled: ids.length > 0,
      };
    }),
  );
};
